import {APIENDPOINT} from '../constants';
var APIURL = window.bookingsUrl + APIENDPOINT;
var noCatering = true;


export default {
  init() {
    var AUTH = window.AUTH;
    var globalBookingId = 0;
    var globaltimeslots = null;
    var globaltakenslots = null;
    var globalStartTime = "00:00";
    var globalEndTime = "00:00";
    var lastEndKey = "2230";
    var globalBookingDetails = {};

//     setActiveStep(0);

//      var field = acf.getField('catering_opening_hours');
// add an action




    function getSlotsForDate (date) {
      var timeslotsHtml = '';
      var takenslots = globaltakenslots;
      var timeslots = globaltimeslots;
      var todaysTakenSlots = [];
      var formattedDate = $.datepicker.formatDate('yy-mm-dd', date);
      if (takenslots != null) {
        for (var j = 0; j < takenslots.length; j++) {
          if (takenslots[j].date === formattedDate) {
            for (var temp = 0; temp < takenslots[j].timeslots.length; temp++) {
              todaysTakenSlots.push(takenslots[j].timeslots[temp].key);
            }
          }
        }
      }
      for (var i = 0; i < timeslots.length; i++) {
        var exists = false;
        var timeslot = timeslots[i];
        for (var pos = 0; pos < todaysTakenSlots.length; pos++) {
          if (timeslot.key === todaysTakenSlots[pos]) {
            exists = true;
            break;
          }
        }

        if (timeslot.key > "0530" && timeslot.key < lastEndKey) {
          timeslotsHtml +=
          `
          <button data-date="${formattedDate}" data-timeslot-id="${timeslot.id}" data-timeslot-from="${timeslot.from}" data-timeslot-to="${timeslot.to}" data-key="${timeslot.key}" class="timeslot-button starttime-button rounded-full text-center w-20 justify-center mx-1 md:mx-0 mt-2 md:mt-1 md:ml-1 bg-secondary-light h-12 block text-md text-secondary-dark ${(isAfter(timeslot.from, date) && !exists) ? '' : 'disabled'}">${timeslot.from}</button>
          `
        }
      }
      for (var fill = 0; fill < 5; fill++) {
        timeslotsHtml += `<div class="mx-1 md:hidden w-20" style="height:0;">&nbsp;</div>`;
      }
      return timeslotsHtml;
    }

    function getEndSlotsFromSlot (selectedSlot, date) {
      var endslots = '';
      var takenslots = globaltakenslots;
      var timeslots = globaltimeslots;
      var todaysTakenSlots = [];
      if (takenslots != null) {
        for (var j = 0; j < takenslots.length; j++) {
          if (takenslots[j].date === date) {
            for (var temp = 0; temp < takenslots[j].timeslots.length; temp++) {
              todaysTakenSlots.push(takenslots[j].timeslots[temp].key);
            }
          }
        }
      }
      endslots += `<button data-to="${selectedSlot.to}" data-key="${selectedSlot.key}" data-timeslot-id="${selectedSlot.id}" class="endtime-button timeslot-button rounded-full text-center w-20 justify-center bg-secondary-light h-12 block text-md text-secondary-dark mx-1 md:mx-0 mt-2 md:mt-1 md:ml-1 ">${selectedSlot.to}</button>`;
      var nextFree = true;
      for (var i = 0; i < timeslots.length; i++) {
        if (timeslots[i].key > selectedSlot.key && timeslots[i].key < lastEndKey) {
          for (var x = 0; x < todaysTakenSlots.length; x++) {
            if (timeslots[i].key === todaysTakenSlots[x]) {
              nextFree = false;
            }
          }
          if (nextFree) {
            endslots += `
              <button data-to="${timeslots[i].to}" data-key="${timeslots[i].key}" data-timeslot-id="${timeslots[i].id}" class="endtime-button timeslot-button rounded-full text-center w-20 justify-center bg-secondary-light h-12 block text-md text-secondary-dark mx-1 md:mx-0 mt-2 md:mt-1 md:ml-1 ">${timeslots[i].to}</button>
              `;
          }
        }
      }
      for (var fill = 0; fill < 5; fill++) {
        endslots += `<div class="mx-1 md:hidden w-20" style="height:0;">&nbsp;</div>`;
      }


      $('.endtimeslots-container').html(endslots);
      setActiveStep(1);
    }

    function setActiveStep (step) {
// 	    console.log("Active Step", step);
      var $first = $('.start-view');
      var $second = $('.second-view');
      var $final = $('.final-view');
      var $datecontainer = $('.datepicker-container');
      var $additionalBooking = $('.additional-booking-view');
      var $confirmation = $('.confirmation-view');

      switch (step) {
        case 0:
          $datecontainer.addClass('flex').removeClass('hidden');
          $first.addClass('flex').removeClass('hidden');
          $second.addClass('hidden').removeClass('flex');
          $final.addClass('hidden').removeClass('flex');
          $additionalBooking.addClass('hidden').removeClass('flex');
          $confirmation.addClass('hidden').removeClass('flex');
          break;
        case 1:
          $datecontainer.addClass('hidden').removeClass('flex');
          $first.addClass('hidden').removeClass('flex');
          $second.addClass('flex').removeClass('hidden');
          $final.addClass('hidden').removeClass('flex');
          $additionalBooking.addClass('hidden').removeClass('flex');
          $confirmation.addClass('hidden').removeClass('flex');
          break;

        case 2:
          $datecontainer.addClass('hidden').removeClass('flex');
          $first.addClass('hidden').removeClass('flex');
          $second.addClass('hidden').removeClass('flex');
          $final.addClass('flex').removeClass('hidden');
          $additionalBooking.addClass('hidden').removeClass('flex');
          $confirmation.addClass('hidden').removeClass('flex');
          break;
        case 3:
          $datecontainer.addClass('hidden').removeClass('flex');
          $first.addClass('hidden').removeClass('flex');
          $second.addClass('hidden').removeClass('flex');
          $final.addClass('hidden').removeClass('flex');
          $additionalBooking.addClass('flex').removeClass('hidden');
          $confirmation.addClass('flex').removeClass('hidden');
          break;

        default:
          $datecontainer.addClass('flex').removeClass('hidden');
          $first.addClass('flex').removeClass('hidden');
          $second.addClass('hidden').removeClass('flex');
          $final.addClass('hidden').removeClass('flex');
          $additionalBooking.addClass('hidden').removeClass('flex');
          $confirmation.addClass('hidden').removeClass('flex');
          break;
      }
    }

    function setTimeslots (timeslots, takenslots) {
      globaltimeslots = timeslots;
      globaltakenslots = takenslots.bookings;
    }

    function setStartTime (startTime) {
      globalStartTime = startTime;
    }

    function getStartTime () {
      return globalStartTime;
    }

    function setEndTime (endTime) {
      globalEndTime = endTime;
    }

    function getEndTime () {
      return globalEndTime;
    }

    function getTimeslots () {
      return [globaltimeslots, globaltakenslots];
    }

    function getBookingDetails () {
      return globalBookingDetails;
    }

    function setBookingDetails (booking) {
      globalBookingDetails = booking;
    }

    function calculateBusinessDays(startDate, endDate){
      // Validate input
      if (endDate < startDate)
          return 0;

      // Calculate days between dates
      var millisecondsPerDay = 86400 * 1000; // Day in milliseconds
      //startDate.setHours(0,0,0,1);  // Start just after midnight
      //endDate.setHours(23,59,59,999);  // End just before midnight
      var diff = endDate - startDate;  // Milliseconds between datetime objects
      var days = Math.ceil(diff / millisecondsPerDay);

      // Subtract two weekend days for every week in between
      var weeks = Math.floor(days / 7);
      days = days - (weeks * 2);

      // Handle special cases
      var startDay = startDate.getUTCDay();
      var endDay = endDate.getUTCDay();

      // Remove weekend not previously removed.
      if (startDay - endDay > 1)
          days = days - 2;

      // Remove start day if span starts on Sunday but ends before Saturday
      if (startDay == 0 && endDay != 6) {
          days = days - 1;
      }

      // Remove end day if span ends on Saturday but starts after Sunday
      if (endDay == 6 && startDay != 0) {
          days = days - 1;
      }

      return days;
    }




    if ($('.single-room').length > 0) {
      var auth = AUTH;
      var url = APIURL + "timeslots/";
      var strings = window.location.pathname.split('\/');
      var paths = [];
      strings.forEach(function (string) {
        if (string.length > 0) {
          paths.push(string);
        }
      });
      var roomid = paths[paths.length - 1];
      var roomurl = APIURL + 'rooms/' + roomid;
      var thisDate;
      if (getUrlVars().date != null) {
        var currentTime = new Date();
        thisDate = new Date(getUrlVars().date);
        thisDate.setHours(currentTime.getHours());
        thisDate.setMinutes(currentTime.getMinutes());
      } else {
        thisDate = new Date();
      }

      var today = $.datepicker.formatDate('yy-mm-dd', new Date());
//       var today=now.getFullYear()+"-"+(now.getMonth() < 10?'0':'')+now.getMonth()+'-'+(now.getDay()<10?'0':'')+now.getDay();
      var bookingsfrom = APIURL + "bookings?from=" + today + "&room=" + roomid;

      var timeslots = $.ajax({
        url: url,
        method: 'GET',
        beforeSend: function (req) {
          req.setRequestHeader('Authorization', auth);
        },
      });

      var room = $.ajax({
        url: roomurl,
        method: 'GET',
        beforeSend: function (req) {
          req.setRequestHeader('Authorization', auth);
        }
      });
      var takenSlots = $.ajax({
        url: bookingsfrom,
        method: 'GET',
        beforeSend: function (req) {
          req.setRequestHeader('Authorization', auth);
        }
      });

      var me = $.ajax({
        url: APIURL + 'users/me',
        method: 'GET',
        beforeSend: function (req) {
          req.setRequestHeader('Authorization', auth);
        }
      });


      /*eslint-disable */
      Promise.all([timeslots, room, takenSlots, me]).then(function (response) {
        var timeslots = response[0]._embedded.timeslots;
        var room = response[1];

        var takenSlots = response[2]._embedded;
        var me = response[3];
        const hoursLeft = me._embedded.company.freeMeetingroomHoursLeft;
        // console.log(room);
        // console.log(me);

        setTimeslots(timeslots, takenSlots);
        var booking = {
          room: room.id,
          user: window.userid,
          catering: 0,
          cateringRequest: "",
          messageToStaff: "",
        };
        setBookingDetails(booking);
        var roomBodyHtml = room.body.replace(/\<br \/>/g, ' \/\/ ');
        var timeslotsHtml = getSlotsForDate(thisDate);

     //    var now = new Date();
     //     now.setHours(24,0,0,0);
		 // var noCatering=true;
		  // var diffDays = parseInt((thisDate - now) / (1000 * 60 * 60 * 24), 10);
		  // if(diffDays >= 1 && thisDate.getUTCHours() >= catering_opening_time && thisDate.getUTCHours()<=catering_closing_time){
			//  noCatering=false;
		  // }

/*
		  console.log(thisDate, "thisDate");
		console.log(diffDays, "diffDays");
        console.log(noCatering, "noCatering");
*/


        var roomInfo = `
        <div class="text-black md:leading-normal mt-6 leading-tight md:text-xl text-left">Your company currently have <span class="hours-left font-bold">${hoursLeft}</span> free hours left this month.</span></div>
        <div class="hidden md:flex mt-6 flex-col text-left room-content">

                  <div class="flex items-center">

                    <h3>${room.title}</h3>
                    <img src="${HOME_URL}/wp-content/themes/epicenter/images/people-icon-black.svg" class="self-start h-6 ml-2" />
                    <p class="text-xl ml-2">${room.capacity}</p>
                  </div>
                  <span class="h-border bg-black rounded-full w-full mr-12 my-4">&nbsp;</span>
                    ${roomBodyHtml}
        </div>

                `;

        var html = `
	        <div class="w-full md:rounded-lg overflow-hidden bg-white flex md:flex-row flex-col mb-6 mt-8">
	        <div class="flex">
            <div class="md:w-64 w-2/5 h-auto" style="background: url('${room.photo}') center center no-repeat; background-size: cover;">&nbsp;</div>
            <div class="md:hidden flex p-6 w-3/5 room-content-mobile">
            <div class="flex flex-col">
          <div class="flex items-end">
            <h3>${room.title}</h3>
            <img src="${HOME_URL}/wp-content/themes/epicenter/images/people-icon-black.svg" class="self-start h-6 ml-auto" />
            <p class="text-xl ml-2">${room.capacity}</p>
          </div>
          <span class="h-border bg-black rounded-full w-full my-2">&nbsp;</span>
            ${roomBodyHtml}
            </div>
            </div>
            </div>
            <!-- start view -->
            <div class="start-view w-full p-6 text-right flex-col flex">
              <p class="font-bold mb-4 text-center alschlange md:text-left text-base md:text-xl text-black alschlange">Choose a start time</p>
                <div class="text-left flex flex-wrap justify-center md:justify-start timeslots-container">
                  ${timeslotsHtml}
                </div>
                <div class="hidden md:block">
                ${roomInfo}
                </div>
            </div>
            <!-- second view -->
            <div class="second-view w-full p-6 text-right hidden flex-col">
              <p class="font-bold mb-2 md:mb-4 text-center md:text-left text-xl text-secondary-dark">Chosen start time:</p>
              <p class="alschlange chosen-start text-secondary-dark text-xl md:text-4xl text-center md:text-left">not set</p>
              <a class="cancel-booking text-black text-lg md:text-xl text-center md:text-left mt-2 text-left mb-4 md:mb-8">CHANGE START TIME</a>
              <p class="font-bold mb-4 text-center alschlange md:text-left text-base md:text-xl text-black">Choose end time</p>
              <div class="text-left flex flex-wrap justify-center md:justify-start endtimeslots-container">

              </div>
              <div class="hidden md:block">
                ${roomInfo}
                </div>
            </div>
            <!-- final view -->
            <div class="final-view w-full p-6 text-right hidden text-left flex-col">
               <p class="font-bold alschlange mb-4 text-center md:text-left text-base md:text-xl text-secondary-dark">Chosen time</p>
               <p class="chosen-date alschlange text-secondary-dark text-xl md:text-4xl text-center md:text-left"></p>
               <a class="cancel-booking cursor-pointer text-black text-lg md:text-xl text-center md:text-left mt-2 text-left mb-8">CHANGE DATE AND TIME</a>
               <p class="text-base md:text-3xl font-bold mb-4 text-left text-black">Price: <span data-currency="${room.currency}" data-priceperhour="${room.pricePerHour.default}" class="price-per-hour"></span></p>
               <p class="mb-4 text-left text-base leading-tight md:leading-normal md:text-xl text-black">The price is calculated from room price, amount of time for the booking and type of membership. Note that hourly discount is included in this calculation, and will be withdrawn on invoicing.</p>
               <!--<p class="text-black text-base leading-tight md:leading-normal md:text-xl text-left">Your company currently have <span class="hours-left font-bold">${hoursLeft}</span> free hours left this month.</span></p>-->
                  ${roomInfo}
           </div>

            <div class="confirmation-view w-full p-6 text-right hidden text-left flex-col">
               <p class="font-bold alschlange mb-4 text-center md:text-left text-base md:text-xl text-secondary-dark">Booking confirmation</p>
               <p class="chosen-date alschlange text-secondary-dark text-xl md:text-4xl text-center md:text-left"></p>
               <p class="passcode-text text-black text-lg dinpromedium md:text-xl text-center md:text-left mt-2 text-left mb-8"></p>
               <p class="mt-4 mb-4 text-left text-base md:leading-normal leading-tight md:text-xl text-black">Please note that the door passcode may have changed at the start of the booking, so please have a look at your upcoming activities before your meeting.</p>
               <div class="flex add-to-calendar">
                  <button class="mt-4 mr-8 cta edit-current-booking rounded-full bg-transparent border-2 border-black text-black text-xl px-16 md:px-10">EDIT BOOKING</button>


               </div>
                  ${roomInfo}
           </div>

           </div>
           `;

        html += `<div class="final-view flex-col hidden">`
          // if(!noCatering){
           html += `<h4 class="font-bold mt-8 text-center alschlange text-2xl text-secondary-dark catering-info-open">Do you want to order anything to the meeting?</h4>
           <div class="mx-auto max-w-xl ">
           <div class="text-center my-4 catering-info-open">
              <label name="catering" class="relative inline-block w-16 h-8"><input class="catering-slider" type="checkbox" /><span class="absolute pin bg-secondary-light rounded-full slider"></span><span class="absolute text-secondary pin-t pin-b pin-l select-text-position text-left slider-on opacity-0 dinpromedium text-xs mx-3">YES</span><span class="absolute pin-t pin-b pin-r select-text-position edit-profile slider-off text-xs dinpromedium text-white mx-3">NO</span></label>
           </div>
              <div class="catering-container mt-8" style="display: none;">
                <div class="md:px-24 px-0">
                  <label for="catering-message" class="text-left text-black alschlange text-lg">Catering request</label>
                  <textarea name="catering-message" class="catering-message dinpromedium mt-1 p-4 w-full min-h-80 bg-white rounded-lg" placeholder="3 water at start&#10;3 coffe at start&#10;3 lunch at 12:00" />
                  <p class="mt-4 text-black text-left text-lg font-bold">Last order/cancellation time 12:00 two working days before delivery.</p>
                  <p class="mt-4 mb-8 text-black text-left leading-tight md:leading-normal">If you wish to order catering, a message will be sent to our restaurant. The restaurant will then contact you to confirm your request. Please note some items takes some time to prepare and must be ordered within a feasible time frame. The restaurant is open for catering from 07.30 to 17.00, enjoy!</p>`;

                  if(catering_menu_url!=""){
                    html += `<a href="${catering_menu_url}" target="_blank"><button class="update-room rounded-full bg-secondary-light text-secondary-dark text-lg md:mx-4 cta">Catering menu</button></a>`;
                    }
               html += ` </div>

              </div>`;
                  // }else{
	                  html+=`<h4 class="font-bold mt-8 text-center alschlange text-2xl text-secondary-dark catering-info-close">${catering_no_catering_str}</h4><div class="mx-auto max-w-xl">`;
                  // }
               html += `
            <span class="rounded-full h-px bg-tertiary-dark inline-flex w-full my-12">&nbsp;</span>
            <div class="md:px-24 px-0">
            <label for="staff-message" class="text-left text-black alschlange text-lg">Message to Epicenter</label>
            <textarea name="staff-message" class="staff-message dinpromedium mt-1 p-4 w-full min-h-80 bg-white rounded-lg" />
            <p class="mt-8 text-black text-left text-lg leading-tight md:leading-normal">If you have any special requirements or message to Epicenter, this message will be sent with an email to our staff.</p>
            </div>

           </div>
           <span class="rounded-full h-px bg-tertiary-dark w-full inline-flex my-12">&nbsp;</span>
           <h4 class="font-bold mt-8 text-center text-2xl md:text-4xl text-secondary-dark">Booking summary</h4>
           <p class="text-lg md:text-xl text-center text-black alschlange font-bold mt-6">Room ${room.title} at ${room.location}</p>
           <p class="text-base md:text-xl text-center alschlange text-black mt-4 chosen-date"></p>
           <div class="flex md:flex-row flex-col mt-8 mb-12 w-4/5 mx-auto">
           <button class="mt-4 cancel-booking rounded-full bg-transparent border-2 border-black text-black text-xl md:mx-10 w-full cta">CANCEL BOOKING</button>
           <button class="mt-4 book-this-room rounded-full bg-secondary-light text-secondary-dark text-xl w-full md:mx-10 cta">CONFIRM BOOKING</button>
           </div>
           <p class="text-red text-xl md:mx-20 leading-tight md:leading-normal mb-12">This booking needs to be cancelled ${room.invoicingThreshold} hours before start time to not be invoiced. If cancelled after this time and up to one hour before the start, you will be partly invoiced. One hour before the meeting is due to start you will be invoiced in full.</p>
           </div>
           `;

        html += `
         <div class="additional-booking-view flex-col hidden">
           <h4 class="font-bold mt-8 text-center text-2xl text-secondary-dark">Do you want to make another booking?</h4>
           <div class="flex justify-center">
              <a href="${HOME_URL}/booking/"><button class="mt-4 mb-12 md:mb-0 rounded-full cursor-pointer bg-secondary-light text-secondary-dark text-xl px-16 mx-6 cta">BOOK A ROOM</button></a>
           </div>
         </div>

         <div class="edit-booking-view flex-col hidden">
            <h4 class="font-bold mt-8 text-center text-2xl text-secondary-dark">Do you want to order anything to the meeting?</h4>
             <div class="mx-auto max-w-xl">
             <div class="text-center my-4">
                <label name="catering" class="relative inline-block w-16 h-8"><input class="update-catering-slider" type="checkbox" /><span class="absolute pin bg-secondary-light rounded-full slider"></span><span class="absolute text-secondary pin-t pin-b pin-l select-text-position text-left slider-on opacity-0 text-xs mx-3">YES</span><span class="absolute pin-t pin-b pin-r select-text-position edit-profile slider-off dinpromedium text-xs text-white mx-3">NO</span></label>
             </div>
                <div class="update-catering-container mt-8" style="display: none;">
                  <div class="md:px-24 px-0">
                    <label for="catering-message" class="text-left text-black alschlange text-base text-lg">Catering request</label>
                    <textarea name="catering-message" class="update-catering-message dinpromedium mt-1 p-4 w-full min-h-80 bg-white rounded-lg" placeholder="3 water at start&#10;3 coffe at start&#10;3 lunch at 12:00" >${booking.cateringRequest}</textarea>
                    <p class="mt-4 text-black text-left text-lg font-bold">Last order/cancellation time 12:00 two working days before delivery.</p>
                    <p class="mt-4 mb-8 text-black text-left leading-tight md:leading-normal">If you wish to order catering, a message will be sent to our restaurant. The restaurant will then contact you to confirm your request. Please note some items takes some time to prepare and must be ordered within a feasible time frame. The restaurant is open for catering from 07.30 to 17.00, enjoy!</p>
                  </div>

                </div>
              <span class="rounded-full h-px bg-tertiary-dark inline-flex w-full my-12">&nbsp;</span>
              <div class="md:px-24 px-0">

              <label for="staff-message" class="text-left text-black alschlange text-lg">Message to Epicenter</label>
              <textarea name="staff-message" class="update-staff-message dinpromedium mt-1 p-4 w-full min-h-80 bg-white rounded-lg" ></textarea>
              <p class="mt-8 text-black text-left text-lg leading-tight md:leading-normal">If you have any special requirements or message to Epicenter, this message will be sent with an email to our staff.</p>
              </div>

             </div>
             <span class="rounded-full h-px bg-tertiary-dark w-full inline-flex my-12">&nbsp;</span>
             <div class="flex md:flex-row flex-col mt-8 mb-12 w-4/5 mx-auto">
             <button class="mt-4 cancel-current-booking rounded-full bg-transparent border-2 border-black text-black text-xl md:mx-10 w-full cta">CANCEL BOOKING</button>
             <button class="mt-4 update-current-room rounded-full bg-secondary-light text-secondary-dark text-xl w-full md:mx-10 cta">UPDATE BOOKING</button>
             </div>
             <p class="text-red text-xl md:mx-20 leading-tight md:leading-normal mb-12">This booking needs to be cancelled ${room.invoicingThreshold} hours before start time to not be invoiced. If cancelled after this time and up to one hour before the start, you will be partly invoiced. One hour before the meeting is due to start you will be invoiced in full.</p>
         </div>
        `;

        /*eslint-enable */
        var $container = $('.single-room');
        $container.html(html);
        changeDate();

      }
      ).catch(function (error) {
        console.log("error", error);
      });
    }
    ;


    function changeDate (date) {
      var slots = getTimeslots();
      var timeslots = slots[0];
      var takenSlots = slots[1];
      var newDate = new Date();
      var $date = $('.room-datepicker');

      if (date) {
        var thisDate = $.datepicker.formatDate('yy-mm-dd', date);
        $date.data('date', thisDate);
        $date.data('hours', newDate.getHours());
        $date.data('minutes', newDate.getMinutes());
        $date.text($.datepicker.formatDate('d M, yy', date));
        dateChanged();
      } else if (getUrlVars().date != null) {
        var urlDate = new Date(getUrlVars().date);
        var today = $.datepicker.formatDate('yy-mm-dd', urlDate);
        $date.text($.datepicker.formatDate('d M, yy', urlDate));
        $date.data('date', today);
        $date.data('hours', newDate.getHours());
        $date.data('minutes', newDate.getMinutes());
      } else {
        var today = $.datepicker.formatDate('yy-mm-dd', newDate);
        $date.text($.datepicker.formatDate('d M, yy', newDate));
        $date.data('date', today);
        $date.data('hours', newDate.getHours());
        $date.data('minutes', newDate.getMinutes());
      }

    }

    function dateChanged () {
      if ($(this).hasClass('disabled')) {
        return;
      }
      var $date = $('.room-datepicker');
      var dir = $(this).data('direction');
      var val = dir === 'next' ? 1 : dir === 'previous' ? -1 : 0;
      var currentDate = new Date($date.data('date'));
      currentDate.setDate(currentDate.getDate() + val);
      currentDate.setHours($date.data('hours'));
      currentDate.setMinutes($date.data('minutes'));
      var $previousButton = $('.room-change-date[data-direction="previous"]');
      var todaysDate = new Date();
      if ((currentDate.getFullYear() === todaysDate.getFullYear()) && (currentDate.getDate() === todaysDate.getDate()) && (currentDate.getMonth() === todaysDate.getMonth())) {
        $previousButton.addClass('disabled');
      } else if ($previousButton.hasClass('disabled')) {
        $previousButton.removeClass('disabled');
      }
      var booking = getBookingDetails();
      var formattedDate = $.datepicker.formatDate('yy-mm-dd', currentDate);
      booking.date = formattedDate;
      $date.data('date', formattedDate);
      $date.val($.datepicker.formatDate('d M, yy', currentDate));
      var timeslotscontainer = $('.timeslots-container');

      timeslotscontainer.html('');

      timeslotscontainer.html(getSlotsForDate(currentDate));
    }

    var $body = $('body');

    $body.on('click', '.book-this-room', function () {
      var booking = getBookingDetails();
      booking.cateringRequest = $('.catering-message').val();
      booking.messageToStaff = $('.staff-message').val();
      $(".book-this-room").addClass("opacity-50 cursor-not-allowed");
      $(".book-this-room").attr("disabled", true);

      $.ajax({
        url: APIURL + 'bookings',
        method: 'POST',
        beforeSend: function (req) {
          req.setRequestHeader('Authorization', auth);
        },
        dataType: "json",
        data: (JSON.stringify(booking)),
        success: function (response) {
	       $(".book-this-room").removeClass("opacity-50 cursor-not-allowed");
		   $(".book-this-room").attr("disabled", false);
          globalBookingId = response.id;
          $('.update-staff-message').text(response.messageToStaff);
          $('.update-catering-message').text(response.cateringRequest);
          $('.passcode-text').text("PASSCODE: " + response.roomDoorCode);


	       var calFromDate=response.from.replace(/\s/, 'T').replace(/-/g, '').replace(/:/g, '');;
	        var calToDate=response.to.replace(/\s/, 'T').replace(/-/g, '').replace(/:/g, '');;
/*
			console.log(date);
			console.log(response, "RESPONSE");
			console.log(calFromDate);
			console.log(takenSlots, "takenSlots");
*/
			$(".add-to-calendar").append(`<a href="${HOME_URL}/wp-admin/admin-ajax.php?action=create_calender_file&passcode=${response.roomDoorCode}&room=${response.roomName}&dateStart=${calFromDate}&dateEnd=${calToDate}"><button class="mt-4 rounded-full bg-transparent border-2 border-black text-black text-xl px-16 md:px-10 cta">Add to calendar</button></a>`);


          setActiveStep(3);
        }, error: function (error) {
	        $(".book-this-room").removeClass("opacity-50 cursor-not-allowed");
		   $(".book-this-room").attr("disabled", false);
          console.log("error", error);
        }
      });
    });
    $body.on('click', '.update-current-room', function () {
	    $(".update-current-room").addClass("opacity-50 cursor-not-allowed");
      $(".update-current-room").attr("disabled", true);
      var data = {
        catering: $(this).prop('checked') ? 1 : 0,
        cateringRequest: $('.update-catering-message').val(),
        messageToStaff: $('.update-staff-message').val()
      };
      $.ajax({
        url: APIURL + 'bookings/' + globalBookingId,
        method: 'PUT',
        data: JSON.stringify(data),
        beforeSend: function (req) {
          req.setRequestHeader('Authorization', AUTH);
        },
        success: function (response) {
	        $(".update-current-room").removeClass("opacity-50 cursor-not-allowed");
		   $(".update-current-room").attr("disabled", false);

          $('.edit-current-booking').removeClass('hidden');
          $('.edit-booking-view').removeClass('flex').addClass('hidden');
          $('.additional-booking-view').removeClass('hidden').addClass('flex');
        },
        error: function (error) {
	         $(".update-current-room").removeClass("opacity-50 cursor-not-allowed");
		   $(".update-current-room").attr("disabled", false);
          console.log(error);
        }

      });
    });

    $body.on('click', '.cancel-current-booking', function () {
      $.ajax({
        url: APIURL + 'bookings/' + globalBookingId,
        method: 'PUT',
        data: JSON.stringify({cancelled: 1}),
        beforeSend: function (req) {
          req.setRequestHeader('Authorization', AUTH);
        },
        success: function (response) {
          window.location = HOME_URL;
        },
        error: function (error) {
          console.log('error', error);
        }
      });
    });

    $body.on('click', '.edit-current-booking', function () {
      $(this).addClass('hidden');
      $('.additional-booking-view').removeClass('flex').addClass('hidden');
      $('.edit-booking-view').removeClass('hidden').addClass('flex');
    });
    $body.on('click', '.catering-slider', function () {
      var booking = getBookingDetails();
      booking.catering = $(this).prop('checked') ? 1 : 0;
      var $parent = $(this).parent('label');
      if ($parent.hasClass('active')) {
        $parent.removeClass('active');
      } else {
        $parent.addClass('active');
      }
      $('.catering-container').toggle();
    });

    $body.on('click', '.update-catering-slider', function () {
      var $parent = $(this).parent('label');
      if ($parent.hasClass('active')) {
        $parent.removeClass('active');
      } else {
        $parent.addClass('active');
      }
      $('.update-catering-container').toggle();
    });
    $body.on('click', '.endtime-button ', function () {
      setEndTime($(this).data('to'));
      var $this = $(this);
      var $priceContainer = $('.price-per-hour');
      var $chosendate = $('.chosen-date');
      var pricePerHour = $priceContainer.data('priceperhour');
      var currency = $priceContainer.data('currency');
      var endTime = getEndTime().split(':');
      var startTime = getStartTime().split(':');
      var hours = parseInt(endTime[0]) - parseInt(startTime[0]);
      var endMin = parseInt(endTime[1]);
      var startMin = parseInt(startTime[1]);
      if (startMin > endMin) {
        hours -= 0.5;
      } else if (endMin > startMin) {
        hours += 0.5;
      }

      var booking = getBookingDetails();
      var ids = [];
//       ids = [ids[0]];
      var numSlots = ((hours / 0.5) - 1);
      var latestSlot = ids[0];
/*
      console.log(getStartTime().replace(":", ""), "TIME");
      console.log(getEndTime().replace(":", ""), "TIME");
*/
      var startKey=getStartTime().replace(":", "");
      var endKey=getEndTime().replace(":", "");
/*
      console.log(booking, "booking");
      console.log($this.data('timeslot-id'), "timeslot-id");
      console.log($this, "$this");

*/
// 	console.log(globaltimeslots, "globaltimeslots");
// 		console.log(booking, "booking");
//       console.log(getSlotsForDate($chosendate), "getSlotsForDate");
		for(var keyI=0; keyI<globaltimeslots.length;keyI++){
			if(globaltimeslots[keyI].key>=startKey && globaltimeslots[keyI].key<endKey){
// 				console.log(globaltimeslots[keyI].id);
				ids.push(globaltimeslots[keyI].id);
			}
		}
/*
      for (var pos = 0; pos < numSlots; pos++) {
        latestSlot += 1;
        ids.push(latestSlot);
      }
*/
      //while(globaltimeslots)
      booking.timeslots = ids;
//       console.log(booking);
      $priceContainer.text((pricePerHour * hours) + ' ' + currency);
      var tempDate = new Date(booking.date);
      $chosendate.text(getStartTime() + ' - ' + getEndTime() + ', ' + $.datepicker.formatDate('d M, yy', tempDate));
      // console.log(booking, "booking");
      // console.log(startKey, "startKey");
      var now = new Date();
      tempDate.setHours(Number(startKey.substring(0, 2)),Number(startKey.substring(2, 4)),0,0);

       $(".catering-info-close").removeClass("hidden");
       $(".catering-info-open").addClass("hidden");
      // console.log(booking.date, "booking.date");
      // console.log(now, "now");
      // console.log(tempDate, "tempDate");
      // console.log(calculateBusinessDays(now, tempDate), "Days");
       // console.log(calculateBusinessDays(now, thisDate), "Days 2");
       let cateringBusinessDays = calculateBusinessDays(now, tempDate);
       // console.log(cateringBusinessDays, "cateringBusinessDays before");
       // console.log(now.getHours()>=12);
       // console.log(now);
       if(now.getHours()>=12){
         cateringBusinessDays-=1;
       };
        // console.log(tempDate.getHours());
       // console.log(cateringBusinessDays, "cateringBusinessDays after");

      if(cateringBusinessDays>=2 && tempDate.getDay() != 0 && tempDate.getDay() !=6 && Number(startKey) >= 730 && Number(startKey) < 1700){
        $(".catering-info-open").removeClass("hidden");
        $(".catering-info-close").addClass("hidden");
      }


      setActiveStep(2);
    });
    $body.on('click', '.cancel-booking', function () {
      setActiveStep(0);
    });
    $body.on('click', '.starttime-button', function () {
      var $this = $(this);
      var to = $this.data('timeslot-to');
      var key = $this.data('key');
      var from = $this.data('timeslot-from');
      var id = $this.data('timeslot-id');
      var date = $this.data('date');

      var booking = getBookingDetails();
      booking.timeslots = [id];
//       console.log(booking.timeslots, "booking.timeslots 1");
      booking.date = date;
      if ($this.hasClass('disabled')) {
        return;
      }

      setStartTime(from);
      $('.chosen-start').html(from);
      getEndSlotsFromSlot({key: key, to: to, from: from}, date);
    });
    $body.on('click', '.room-change-date', dateChanged);


    var $datepicker = $('.room-datepicker');

    var date;
    if (getUrlVars().date != null) {
      date = new Date(getUrlVars().date);
      if (date.setHours(0, 0, 0, 0) == new Date().setHours(0, 0, 0, 0)) {
        $('.room-change-date[data-direction="previous"]').addClass('disabled');
      }
    } else {
      date = new Date();
    }

    var monthNames = [
      "Jan", "Feb", "Mar",
      "Apr", "May", "Jun", "Jul",
      "Aug", "Sep", "Oct",
      "Nov", "Dec"
    ];


    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();

    $datepicker.val(day + ' ' + monthNames[monthIndex] + ', ' + year);
    $datepicker.datepicker({
      dateFormat: 'd M, yy',
      minDate: new Date(),
      onSelect: function (dateText, inst) {
        changeDate(new Date(inst.currentYear, inst.currentMonth, inst.currentDay));
      }
    });

    function isAfter (timeslotHours, currentDate) {
      var todaysDateString = $.datepicker.formatDate('yy-mm-dd', new Date());
      var currentDateString = $.datepicker.formatDate('yy-mm-dd', currentDate);
      if (todaysDateString !== currentDateString) {
        return true;
      }
      var time = timeslotHours.split(':');
      var hours = parseInt(time[0]);
      var minutes = parseInt(time[1]);

      if (hours < currentDate.getHours()) {
        return false;
      } else if (hours === currentDate.getHours() && minutes < currentDate.getMinutes()) {
        return false;
      }
      return true;
    }

    Date.prototype.yyyymm = function () {
      var mm = this.getMonth() + 1; // getMonth() is zero-based

      return [this.getFullYear(),
        (mm > 9 ? '' : '0') + mm,
      ].join('-');
    };

    function getUrlVars () {
      var vars = {};
      var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,
      function (m, key, value) {
        vars[key] = value;
      });
      return vars;
    }
  }
}
